export function getCurrentTimestamp() {

    let date = new Date();

    let hour = date.getHours();
    let min = date.getMinutes();
    let sec = date.getSeconds();

    return (hour < 10 ? "0" : "") + hour + ":" +
        (min < 10 ? "0" : "") + min + ":" +
        (sec < 10 ? "0" : "") + sec;

}

export function getCurrentDateTimestamp() {

    let date = new Date();

    return date.getFullYear() + "-"
        + ((date.getMonth()+1) < 10 ? "0" : "") + (date.getMonth()+1)  + "-"
        + (date.getDate() < 10 ? "0" : "") + date.getDate() + " "
        + (date.getHours() < 10 ? "0" : "") + date.getHours() + ":"
        + (date.getMinutes() < 10 ? "0" : "") + date.getMinutes() + ":"
        + (date.getSeconds() < 10 ? "0" : "") + date.getSeconds();

}
export function getLocalDateTimeString() {

    let date = new Date();

    return date.getFullYear() + "-"
        + ((date.getMonth()+1) < 10 ? "0" : "") + (date.getMonth()+1)  + "-"
        + (date.getDate() < 10 ? "0" : "") + date.getDate() + "T"
        + (date.getHours() < 10 ? "0" : "") + date.getHours() + ":"
        + (date.getMinutes() < 10 ? "0" : "") + date.getMinutes() + ":"
        + (date.getSeconds() < 10 ? "0" : "") + date.getSeconds();

}

export function getStartOfMonth(date = new Date()) {
    date.setDate(1);
    return date;
}

export function getStartOfDay(date = new Date()) {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
}

export function addDays(date, days) {
    let newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
}

export function addSeconds(date, seconds) {
    let newDate = new Date(date);
    newDate.setSeconds(newDate.getSeconds() + seconds);
    return newDate;
}
